import React from "react";
import * as Styles from "../../../../../../common-deprecated/styles/v2/toyota/custom/services/SharedService";
import * as Type from "../../../../../../common-deprecated/styles/v2/toyota/globals/Type";
import * as Button from "../../../../../../common-deprecated/styles/v2/toyota/components/Button";
import * as Flex from "../../../../../../common-deprecated/styles/v2/toyota/globals/Flex";
import Icon from "../../../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import { IconWrapper } from "../../../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import type { ServiceProductType } from "../../../../../../common-deprecated/types/CommonTypes";
import { BnbLabel } from "../../../utils/labels";
import useServiceProduct from "../../../hooks/shared/serviceplans/useServiceProduct";
import type { BuildAndBuyDispatchType } from "../../../redux/store";
import { showModal } from "../../../../../../common-deprecated/redux/actions/ModalActions";
import { MODAL_CONTENT } from "../../../../../../common-deprecated/utils/modalConstants";
import Price from "../common/price/Price";
import { trackCustomizeConfigItem } from "../../../utils/tracking";
import { NavStep } from "../../../../shared-logic/utils/Navigation";
import { useDispatch } from "../../../../../../shared-logic/redux/store";

const ServiceProduct = ({ serviceProduct }: { serviceProduct: ServiceProductType }): JSX.Element => {
    const dispatch = useDispatch<BuildAndBuyDispatchType>();
    const { actions, serviceProductContent } = useServiceProduct(serviceProduct);
    const { selectServiceProduct, deSelectServiceProduct } = actions;
    const { selected } = serviceProductContent;

    return (
        <Styles.ServiceWrapper selected={selected}>
            {serviceProduct.image && (
                <Styles.Banner>
                    <Styles.Image src={serviceProduct.image} height={170} />
                </Styles.Banner>
            )}

            <Styles.Header>
                <Styles.ServiceTags>
                    {!serviceProduct.financeable && (
                        <Styles.ServiceTag>
                            <BnbLabel label="nonFinanceableServicePlans" />
                        </Styles.ServiceTag>
                    )}
                    {serviceProduct.exclusiveOnline && (
                        <Styles.ServiceTag>
                            <BnbLabel label="exclusiveOnlineServicePlans" />
                        </Styles.ServiceTag>
                    )}
                </Styles.ServiceTags>
                <Styles.Title>{serviceProduct.name}</Styles.Title>
            </Styles.Header>

            {serviceProduct.tooltip && (
                <Styles.Description dangerouslySetInnerHTML={{ __html: serviceProduct.tooltip }} />
            )}

            <Styles.ListWrapper>
                {!!serviceProduct.description && (
                    <Styles.ServicePlanDescription
                        dangerouslySetInnerHTML={{
                            __html: serviceProduct.description!,
                        }}
                    />
                )}
                <Styles.TradeInWrapper>
                    <Styles.MonthlyPriceWrapper>
                        <Type.Strong>
                            <Price price={serviceProduct.price} />
                        </Type.Strong>
                    </Styles.MonthlyPriceWrapper>
                    {!!serviceProduct.footNote && (
                        <Styles.Footnote
                            onClick={(event) => {
                                event.preventDefault();
                                dispatch(showModal({ type: MODAL_CONTENT, content: serviceProduct.footNote }));
                            }}
                        >
                            <BnbLabel label="servicesTermsAndConditions" />
                        </Styles.Footnote>
                    )}
                </Styles.TradeInWrapper>
            </Styles.ListWrapper>
            <Flex.Row>
                <Flex.Col width={1} display="flex" justifyContent="flex-end">
                    <Button.Checkbox
                        type="button"
                        selected={selected}
                        onClick={(event) => {
                            if (!selected) {
                                selectServiceProduct();
                                trackCustomizeConfigItem(NavStep.Services, "add-services");
                            } else {
                                event.preventDefault();
                                deSelectServiceProduct();
                                trackCustomizeConfigItem(NavStep.Services, "remove-services");
                            }
                        }}
                    >
                        <IconWrapper>
                            <Icon variant={selected ? "close" : "plus"} />
                        </IconWrapper>
                    </Button.Checkbox>
                </Flex.Col>
            </Flex.Row>
        </Styles.ServiceWrapper>
    );
};

export default ServiceProduct;
